import { axios, def, handleError } from './internal';

function AdminMlLogs(host, port, onSuccess, onError) {
    axios
        .post('/api/admin_ml_logs', { host, port })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) onSuccess(res.data.data);
            else onError?.(res.data.message ?? 'Failed');
        })
        .catch((err) => {
            onError?.(err.message ?? 'Request failed');
            handleError(err);
        });
}

export { AdminMlLogs };
